export const animations = {
  shimmer: '1s linear infinite',
  slideInRight: 'transform 0.3s ease-out',
};
